module.exports = __webpack_public_path__ + "static/media/img145.f6e591e2.jpg";